import { render, staticRenderFns } from "./ReadArticle.vue?vue&type=template&id=60506237&scoped=true&"
import script from "./ReadArticle.vue?vue&type=script&lang=js&"
export * from "./ReadArticle.vue?vue&type=script&lang=js&"
import style0 from "./ReadArticle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReadArticle.vue?vue&type=style&index=1&id=60506237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60506237",
  null
  
)

export default component.exports